import * as types from './types';

const INITIAL_STATE = {
  loading: false,
  error: null,
  cycleMenus: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.GET_RECIPE_PREP_CYCLE_MENUS_SUCCESS:
      return {
        ...state,
        cycleMenus: payload,
      };
    case types.GET_RECIPE_PREP_CYCLE_MENUS_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.GET_RECIPE_PREP_CYCLE_MENUS_ERROR:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/state/reducer.js